import { css } from "@emotion/react";
import { ReactNode, useEffect, useLayoutEffect, useState, useRef } from "react";
import { Sidebar } from "../sidebar";
import { useAppSelector } from "../../redux/hooks";
import { AuthContextType, useAuth } from "../../auth/auth-provider";
import { useLocation } from "react-router-dom";
interface iLayout {
  children: ReactNode;
}
export const Layout: React.FC<iLayout> = ({ children }) => {
  const [screenMobile, setScreenMobile] = useState(false);
  const { pathname } = useLocation();
  const screenOmnichannel =
    pathname === "/omnichannel" || pathname === "/omnichannel/";
  const sidebarChats = useAppSelector((state) => state.sidebar.sidebarChats);
  const { user } = useAuth() as AuthContextType;
  const scriptLoaded = useRef(false);

  useLayoutEffect(() => {
    if (scriptLoaded.current || screenOmnichannel || window.innerWidth < 500)
      return;

    if (process.env.NODE_ENV === "production") {
      const script = document.createElement("script");

      // @ts-ignore
      window.icwToken = process.env.BOT_TOKEN;

      script.src = `https://${process.env.CHAT_URL}/main.js`;
      document.body.appendChild(script);

      scriptLoaded.current = true;
    }
  }, [screenOmnichannel, user]);

  useEffect(() => {
    const chatElements = document.getElementsByClassName("imbot-chat");
    for (const element of chatElements) {
      (element as HTMLElement).style.display = screenOmnichannel
        ? "none"
        : "block";
    }
  }, [pathname]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 500) {
        setScreenMobile(true);
      } else {
        setScreenMobile(false);
      }
    }
    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {!screenMobile ? (
        <div
          style={{ backgroundColor: "#f5f5f5", overflow: "hidden" }}
          className="h-screen flex relative"
        >
          <Sidebar />
          <div
            css={css`
              background-color: #f5f5f5;
              flex: 1 1 auto;
              height: 100%;
              overflow-y: hidden;
            `}
          >
            {children}
          </div>
        </div>
      ) : (
        <div
          css={css`
            display: flex;
            background: #f5f5f5;
            overflow: hidden;
            width: 100vw;
            height: 100vh;
            flex-direction: column;
          `}
        >
          <div
            css={css`
              background-color: #f5f5f5;
              flex: 1 1 auto;
              overflow: auto;
            `}
          >
            {children}
          </div>
          {!screenOmnichannel ? (
            <Sidebar />
          ) : (
            <>{sidebarChats ? <Sidebar /> : null}</>
          )}
        </div>
      )}
    </>
  );
};
